import * as React from "react";
import Box from "@mui/material/Box";
import { Drawer, Stack } from "@mui/material";
import InsightsIcon from "@mui/icons-material/Insights";
import TourIcon from "@mui/icons-material/Tour";
import AdvancedInsightsRadioGroupRating from "src/scenes/dashboard/overview-components/advanced-insights-assets/advanced-insights-user-opinion";
import styled from "styled-components";
import Button from "@mui/material/Button";

const MissionsButton = styled(Button)`
    background-color: ${({ theme }) => theme.palette.background.default};
    font-size: 12px;
    z-index: 10;
`;

const AnalysisMissionsDrawer = ({ open, setOpen, data }) => {
    const toggleDrawer = () => (event) => {
        if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
            return;
        }
        setOpen(false);
    };

    const list = () => (
        <Box
            sx={{
                width: "487px",
                height: "100%",
                backgroundColor: "#0e0e0e",
                padding: "28px",
            }}
            role="presentation"
            onKeyDown={toggleDrawer(false)}
        >
            <Stack direction="column" style={{ height: "100%" }} justifyContent="space-between">
                <Stack direction="column">
                    <Stack direction="row" alignItems="center">
                        <InsightsIcon style={{ paddingRight: "8px" }} />
                        <p>Remediation Missions</p>
                    </Stack>
                    <p
                        style={{
                            marginTop: "16px",
                            marginBottom: "16px",
                            fontSize: "12px",
                            fontWeight: "200",
                        }}
                    >
                        Select a mission in order to remediate the root causes of anomalies
                        concerning your lead time.
                    </p>
                    {data &&
                        data.map((mission) => (
                            <Stack direction="column" mt={1} mb={1}>
                                <p style={{ marginBottom: "8px" }}>{mission.title}</p>
                                <Stack direction="row" alignItems="center">
                                    <p
                                        style={{
                                            fontSize: "12px",
                                            margin: "0",
                                            maxWidth: "298px",
                                        }}
                                    >
                                        {mission.support}
                                    </p>
                                    <MissionsButton
                                        variant="outlined"
                                        color="secondary"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setOpen(false);
                                        }}
                                        startIcon={<TourIcon />}
                                        style={{
                                            textDecoration: "auto",
                                            textAlign: "center",
                                            paddingRight: "12px",
                                            width: "196px",
                                            height: "32px",
                                        }}
                                    >
                                        set mission
                                    </MissionsButton>
                                </Stack>
                            </Stack>
                        ))}
                </Stack>
                <Stack direction="column">
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        <p style={{ opacity: "0.5", fontSize: "12px" }}>
                            Did you find this useful?
                        </p>
                        <AdvancedInsightsRadioGroupRating />
                    </Stack>
                </Stack>
            </Stack>
        </Box>
    );

    return (
        <React.Fragment key="right">
            <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                {list()}
            </Drawer>
        </React.Fragment>
    );
};

export default AnalysisMissionsDrawer;
